import { render } from "./Portfolio.vue?vue&type=template&id=e016b436"
import script from "./Portfolio.vue?vue&type=script&lang=js"
export * from "./Portfolio.vue?vue&type=script&lang=js"

import "./Portfolio.vue?vue&type=style&index=0&id=e016b436&lang=css"
script.render = render

export default script